module.exports = __webpack_public_path__ + "static/media/Coding-bro-purple.27cd539f.svg";